import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment';

import HourLabel from './HourLabel';
import MinuteBlock from './MinuteBlock';

import './HourBlock.css';

const minutesInHour = 60;

export default class HourBlock extends PureComponent {
    static propTypes = {
        hour: PropTypes.object.isRequired,
        newStart: PropTypes.object,
        newEnd: PropTypes.object,
        minutesInBlock: PropTypes.number.isRequired,
        roundedStart: PropTypes.object.isRequired,
        roundedEnd: PropTypes.object.isRequired,
        roundedMinStart: PropTypes.object.isRequired,
        roundedMaxEnd: PropTypes.object.isRequired,
        canEditStart: PropTypes.bool.isRequired,
        canEditEnd: PropTypes.bool.isRequired,
        editingStart: PropTypes.bool.isRequired,
        editingEnd: PropTypes.bool.isRequired,
        onTimeSelected: PropTypes.func.isRequired,
        onEditingStart: PropTypes.func.isRequired,
        onEditingEnd: PropTypes.func.isRequired,
        focusTime: PropTypes.object,
        onScrollTo: PropTypes.func.isRequired,
        startTimeUnavailabilityReasons: PropTypes.array.isRequired,
        endTimeUnavailabilityReasons: PropTypes.array.isRequired,
        onUnavailableTimeSlotClicked: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            // true because we will always want to scroll the first render
            focusTimeChanged: props.focusTime != null,
        };
    }

    componentWillReceiveProps(nextProps) {

        this.setState({
            focusTimeChanged: nextProps.focusTime && this.props.focusTime !== nextProps.focusTime,
        });
    }

    isScrollToMinuteBlock(time) {
        const timeEnd = time.clone().add(this.props.minutesInBlock, `m`);
        return this.props.focusTime.isBetween(time, timeEnd, null, `[)`);
    }

    render() {
        const blocksInHour = Math.ceil(minutesInHour / this.props.minutesInBlock);

        let minuteBlocksJsx = [];
        for (let i = 0; i < blocksInHour; i++) {
            const time = this.props.hour.clone().add(i * this.props.minutesInBlock, `m`);
            const shouldScrollTo = this.state.focusTimeChanged && this.isScrollToMinuteBlock(time);

            minuteBlocksJsx.push(
                <MinuteBlock
                    key={i}
                    time={time}
                    duration={this.props.minutesInBlock}
                    newStart={this.props.newStart}
                    newEnd={this.props.newEnd}
                    roundedStart={this.props.roundedStart}
                    roundedEnd={this.props.roundedEnd}
                    roundedMinStart={this.props.roundedMinStart}
                    roundedMaxEnd={this.props.roundedMaxEnd}
                    canEditStart={this.props.canEditStart}
                    canEditEnd={this.props.canEditEnd}
                    editingStart={this.props.editingStart}
                    editingEnd={this.props.editingEnd}
                    onTimeSelected={this.props.onTimeSelected}
                    onEditingStart={this.props.onEditingStart}
                    onEditingEnd={this.props.onEditingEnd}
                    shouldScrollTo={shouldScrollTo}
                    onScrollTo={this.props.onScrollTo}
                    startTimeUnavailabilityReasons={this.props.startTimeUnavailabilityReasons}
                    endTimeUnavailabilityReasons={this.props.endTimeUnavailabilityReasons}
                    onUnavailableTimeSlotClicked={this.props.onUnavailableTimeSlotClicked}
                 />
            );
        }

        return (
            <div className="hour-block">
                <HourLabel hour={this.props.hour.format(`H`)} />
                <div className="minute-blocks">
                    {minuteBlocksJsx}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/TimeSelector/HourBlock.jsx